import { useMount } from 'ahooks';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import RevxTable, { TableColumnsType } from 'components/RevxTable';
import {
  PartialResellerCertificate,
  ResellerCertificate,
} from 'domains/resellerCertificateDomain';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import states from 'states-us';

export const ResellerCertificateAdminTable = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const loading = useAppSelector(
    (state) => state.loading.effects.resellerCertificate.getPage
  );
  const pagedData = useAppSelector(
    (state) => state.resellerCertificate.pagedData
  );
  const curItem = useAppSelector((state) => state.resellerCertificate.curItem);
  const columns: TableColumnsType<ResellerCertificate> = [
    {
      title: t('common.id'),
      width: 60,
      dataIndex: 'id',
    },
    {
      title: t('common.state'),
      width: 140,
      dataIndex: 'state',
      render: (value) =>
        `${states.find((item) => item.abbreviation === value)?.name} (${
          states.find((item) => item.abbreviation === value)?.abbreviation
        })`,
    },
    {
      title: t('platform.resellerCertificate.columnTitle.certificateId'),
      width: 140,
      dataIndex: 'certificateId',
      render: (value) => value || '-',
    },
    {
      title: t('platform.resellerCertificate.columnTitle.updateTime'),
      width: 140,
      dataIndex: 'updateAt',
      render: (value) => (value ? moment(value).format('YYYY-MM-DD') : ''),
    },
    {
      title: t('common.actions'),
      key: 'actions',
      fixed: 'right',
      width: 60,
      render: (value, record) => (
        <RevxButton
          type="link"
          key="view"
          size="small"
          onClick={() =>
            dispatch.resellerCertificate.setState({ curItem: record })
          }
        >
          {t('common.edit')}
        </RevxButton>
      ),
    },
  ];
  useMount(async () => {
    dispatch.resellerCertificate.getPage();
  });
  return (
    <div hidden={!!curItem}>
      <RevxTable<ResellerCertificate>
        loading={loading}
        columns={columns}
        size="small"
        // pagination={{
        //   pageSize: pageSize,
        //   current: pageNumber,
        //   total: pagedData?.totalElements,
        // }}
        rowClassName={(record: PartialResellerCertificate) => {
          if (curItem?.id === record.id) {
            return 'editing';
          }
          return '';
        }}
        indentSize={20}
        dataSource={pagedData || []}
        // onChange={onTableChange}
      />
    </div>
  );
};
